/* oxlint-disable grafit-oxlint/no-tailwind-font-classes -- Typography 2 migration */
import { iconVariants } from "@grafit/design-system/components/icons/variants-icon";
import { Button } from "@grafit/design-system/components/molecules/button";
import { ShinyText } from "@grafit/design-system/components/molecules/shiny-text";
import { Trans } from "@grafit/i18n";
import { AppWindowIcon, MilestoneIcon } from "lucide-react";
import { markVersionReloadAttempt } from "./app-update";

export const AppUpdatePage = () => {
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-12">
      <div className="flex gap-12">
        <MilestoneIcon className={iconVariants({ size: "hero" })} strokeWidth={1.44} />
        <AppWindowIcon className={iconVariants({ size: "hero" })} strokeWidth={1.44} />
      </div>

      <ShinyText className="max-w-3xl">
        <h1 className="text-center text-3xl">
          <Trans i18nKey="app-update-page.title" />
        </h1>
      </ShinyText>

      <h2 className="max-w-xl text-center text-xl">
        <Trans i18nKey="app-update-page.sub-title" />
      </h2>

      <Button
        variant={{ kind: "accent", renderMode: "fill", size: "m" }}
        onClick={() => {
          markVersionReloadAttempt();
          window.location.assign("/");
        }}
        type="button"
      >
        <Trans i18nKey="app-update.toast.action" />
      </Button>
    </div>
  );
};
